"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_MEMBERSHIP_INVITE_DATA = exports.GET_ADDONS_BY_CONTENTFUL_SKUS = exports.GENERATE_INVOICE = exports.GET_FIRM_BILLING_INVOICES = exports.INIT_QUOTE_GENERATION = exports.REMOVE_DISCOUNT_CODE_FROM_QUOTE = exports.APPLY_DISCOUNT_CODE_TO_QUOTE = exports.GET_GENERATE_INVOICE_MODAL_INFO = exports.INVALIDATE_QUOTE = exports.GENERATE_QUOTE = exports.CHECK_USER_FOR_REMOVE_PRORATION_QUALIFICATION = exports.SUBMIT_QUOTE_BATCH = exports.REMOVE_FIRM_BILLING_QUOTE_ITEMS = exports.SAVE_FIRM_BILLING_QUOTE_ITEMS = exports.SEND_MEMBERSHIP_UPGRADE_REMINDER = exports.SEND_FIRM_ROSTER_INVITE_REMINDER = exports.REMOVE_FIRM_ROSTER_MEMBER = exports.TOGGLE_IS_PAID_BY_FIRM = exports.UPGRADE_FIRM_ROSTER_INVITE = exports.UPDATE_FIRM_ROSTER = exports.GET_FIRM_ADMIN_ORGANIZATION_DETAILS = exports.INIT_FIRM_ROSTER_DYNAMO_TABLE = exports.REMOVE_MEMBERSHIP_INVITE = exports.GET_MEMBERSHIP_INVITE = exports.LIST_MEMBERSHIP_INVITE = exports.IMPORT_B2B_CLIENT_ADMINS = exports.GET_FIRM_ROSTER_MEMBERS = exports.GET_ORGANIZATIONS_BY_ACCOUNT_IDS = void 0;
// TODO: let's use one field organizationCapabilities/Types instead of isFirmBillingEnabled, isCIMAFirmBillingEnabled, isFLPFirmBillingEnabled. These fields should be refactored.
exports.GET_ORGANIZATIONS_BY_ACCOUNT_IDS = `
  {
    organizations {
            id
            name
            creditHoldStatus
            hasAICPAUid
            isFirmBillingEnabled
            isCIMAFirmBillingEnabled
            aicpaFirmBillingType
            cimaFirmBillingType
            isFLPFirmBillingEnabled
            parentId
            currentParentId
            billingAddress {
              addressLine1
              city
              state
              zipCode
              country
            }
            shippingAddress {
              addressLine1
              city
              state
              zipCode
              country
            }
            type
            phone
            organizationCapabilities {
              type
              isFLP
            }
            currency
          }
  }
`;
exports.GET_FIRM_ROSTER_MEMBERS = `
  query getFirmRosterMembers($rootOrganizationId: String!, $offset: Int!, $limit: Int, $searchText: String!, $filters: FirmAdminFilters!, $includeAddons:Boolean, $useFilterRenewalEndDate:Boolean, $useFirmRosterCaseInsensitiveSearch:Boolean) {
    getFirmRosterMembers(rootOrganizationId:$rootOrganizationId, offset:$offset, limit:$limit, filters:$filters, searchText: $searchText, includeAddons:$includeAddons, useFilterRenewalEndDate:$useFilterRenewalEndDate, useFirmRosterCaseInsensitiveSearch: $useFirmRosterCaseInsensitiveSearch) {
        result {
          userId
          organizationId
          rootOrganizationId
          oktaId
          isHonorary
          firstName
          firstNameLower
          lastName
          lastNameLower
          email
          isPaidByFirm
          isPaidByFlp
          isAddToFirmBillingDisabled
          isAddToFlpFirmBillingDisabled
          isAdmin
          isStudent
          position
          membershipType
          membershipTier
          membershipStatus
          branchCountry
          branchState
          branchCity
          officeLocation
          createDateTime
          applicationNumber
          aicpaId
          relationWithFirm
          deleteFlagFirmBilling
          deleteFlagFirmRelation
          updateFlagFirmBilling
          updateFlagFirmRelation
          quoteStatus
          oktaStatus
          zuoraAccountNumber
          quoteItems {
            productId
            variantSku
            newVariantSku
            newCentPrice
            centPrice
            channelId
            subscriptionNumber
            renewalDate
            subscriptionStartDate
            ratePlanId
            isIncludedInFirmBilling
            action
            isMembership
            isEnrollmentFee
            addonType
            options
          }
          quoteCurrency
          isSubscriptionsFetched
          subscriptions {
            subscriptionNumber
            subscriptionId
            renewalDate
            subscriptionStartDate
            ratePlanId
            subscriptionAccountId
            subscriptionInvoiceOwnerId
            userName
            oktaId
            aicpaId
            email
            productName
            sku
            productPrice
            memberDiscount
            invoiceId
            invoiceBalance
            membershipType
          }
          expiryDate
          subscriptionStatus
          flpSubscriptionType
          flpSubscriptionDuration
          flpSubscriptionVariantSku
          learningPathway
          applicationPartLearningPathwaysFLP
          applicationPartLearningPathwaysPQ
          isFLPView
          isFlpUpgradeModalView
          isBillingView
          accountCurrency
          accountEntity
          address {
            addressLine1
            zipCode
            country
            state
            city
          }
        }
        totalCount
        isPaidByFirmCount
        isPaidByFlpCount
        isInFirmRosterCount
        FLPCount
        quotesStatus
        quotesLength
        flpQuotesStatus
        flpQuotesLength
        isDataLoaded
        isSubscriptionsDataLoaded
        includedTotal
        notIncludedTotal
      }
  }`;
exports.IMPORT_B2B_CLIENT_ADMINS = `
  mutation ($organizationId: String!, $adminDataRows: [FirmRosterEmployeeInvite],  $csv: Upload, $isFLP: Boolean, $subscriptions: JSON, $isCima: Boolean, $organizationType: String!){
    uploadFirmRosterEmployeeInvites(organizationId: $organizationId, adminDataRows: $adminDataRows, csv: $csv, isFLP:$isFLP, subscriptions: $subscriptions, isCima: $isCima, organizationType: $organizationType){
        success
    }
  }
`;
exports.LIST_MEMBERSHIP_INVITE = `
  query listMembershipInvites($accountId: String!, $offset: Int!, $limit: Int, $searchText: String!, $filters: FirmAdminFilters!, $isFLP: Boolean) {
    listMembershipInvites(accountId: $accountId, offset: $offset, limit: $limit, searchText: $searchText, filters: $filters, isFLP: $isFLP) {
      result {
        inviteId
        email
        organizationId
        firstName
        lastName
        membershipType
        firmBillingAdminEmail
        isPaidByFirm
        membershipTier
        senderAicpauid
        position
        status
        createDateTime
        lastReminderDate
        duration
        flpSubscriptionType
        isFLP
        isPaidByFLP
      }
      totalCount
    }
  }`;
exports.GET_MEMBERSHIP_INVITE = `
  query getMembershipInvite($inviteId: String!) {
    getMembershipInvite(inviteId: $inviteId) {
      inviteId
      email
      organizationId
      firstName
      lastName
      membershipType
      firmBillingAdminEmail
      isPaidByFirm
      membershipTier
      senderAicpauid
      position
      status
      createDateTime
      lastReminderDate
      productId
      slug
      isFLP
      isPaidByFLP
      flpSubscriptionType
      duration
    }
  }`;
exports.REMOVE_MEMBERSHIP_INVITE = `
  mutation ($organizationId: String!, $inviteIds: [String!]!) {
    removeMembershipInvite(organizationId: $organizationId, inviteIds: $inviteIds)
}`;
exports.INIT_FIRM_ROSTER_DYNAMO_TABLE = `
  query ($orgId: String!, $isRefreshRequested: Boolean) {
    initFirmRosterDynamoTable(orgId: $orgId, isRefreshRequested: $isRefreshRequested)
}`;
exports.GET_FIRM_ADMIN_ORGANIZATION_DETAILS = `
  query ($orgId: String!) {
    getFirmAdminOrganizationDetails(orgId: $orgId)
}`;
exports.UPDATE_FIRM_ROSTER = `
  mutation($rootOrganizationId: String!, $userList: [UpdateFirmRosterMemberInput!]!) {
    updateFirmRoster(rootOrganizationId: $rootOrganizationId, userList: $userList)
  }
`;
exports.UPGRADE_FIRM_ROSTER_INVITE = `
  mutation ($rootOrganizationId: String!, $records: [UpgradeFirmRosterInviteInput]!){
    upgradeFirmRosterEmployeeInvites(rootOrganizationId: $rootOrganizationId, records: $records){
        success
    }
  }
`;
exports.TOGGLE_IS_PAID_BY_FIRM = `
  mutation($rootOrganizationId: String!, $userIds: [String]!, $isPaidByFirm: Boolean, $subscriptions: JSON, $isPaidByFlp: Boolean, $organizationName: String, $adminName: String, $overrideIsAddToFlpFirmBillingDisabled: Boolean, $isForCancelInvoice: Boolean) {
    toggleIsPaidByFirm(rootOrganizationId: $rootOrganizationId, userIds: $userIds, isPaidByFirm: $isPaidByFirm, subscriptions: $subscriptions, isPaidByFlp: $isPaidByFlp, organizationName: $organizationName, adminName: $adminName, overrideIsAddToFlpFirmBillingDisabled: $overrideIsAddToFlpFirmBillingDisabled, isForCancelInvoice: $isForCancelInvoice)
  }
`;
exports.REMOVE_FIRM_ROSTER_MEMBER = `
  mutation ($organizationId: String!, $userIds: [String!]!, $organizationName: String!, $isFLPLapsed: Boolean, $isSkipEmployee: Boolean, $shouldOnlyUpdateFlpFirmBilling: Boolean){
    removeFirmRosterMembers(organizationId: $organizationId, userIds: $userIds, organizationName: $organizationName, isFLPLapsed: $isFLPLapsed, isSkipEmployee: $isSkipEmployee, shouldOnlyUpdateFlpFirmBilling: $shouldOnlyUpdateFlpFirmBilling)
  }
`;
exports.SEND_FIRM_ROSTER_INVITE_REMINDER = `
  mutation ($rootOrganizationId: String!, $inviteIds: [String!]!) {
    sendFirmRosterInviteReminder(rootOrganizationId: $rootOrganizationId, inviteIds: $inviteIds)
  }
`;
exports.SEND_MEMBERSHIP_UPGRADE_REMINDER = `
  mutation ($rootOrganizationId: String!, $inviteIds: [String!]!) {
    sendMembershipUpgradeReminder(rootOrganizationId: $rootOrganizationId, inviteIds: $inviteIds)
  }
`;
exports.SAVE_FIRM_BILLING_QUOTE_ITEMS = `
  mutation($quotes: [Quote!]!) {
    saveFirmBillingQuoteItems(quotes: $quotes)
  }`;
exports.REMOVE_FIRM_BILLING_QUOTE_ITEMS = `
  mutation($rootOrganizationId: String!, $userIds: [String!]!) {
    removeFirmBillingQuoteItems(rootOrganizationId: $rootOrganizationId, userIds: $userIds)
  }`;
exports.SUBMIT_QUOTE_BATCH = `
  mutation($index: Int!, $userIds: [String]!, $rootOrganizationId: String!, $renewalSeasonData: JSON, $orderNumber: String, $previewJobIds: [String], $useRemoveProration: Boolean) {
    submitQuoteBatch(index: $index, userIds: $userIds, rootOrganizationId: $rootOrganizationId, renewalSeasonData: $renewalSeasonData, orderNumber: $orderNumber, previewJobIds: $previewJobIds, useRemoveProration: $useRemoveProration) {
      previewJobIds,
      index
    }
  }
`;
exports.CHECK_USER_FOR_REMOVE_PRORATION_QUALIFICATION = `
  mutation($rootOrganizationId: String!, $oktaId: String!) {
    checkUserRemoveProrationQualification(rootOrganizationId: $rootOrganizationId, oktaId: $oktaId) 
  }
`;
exports.GENERATE_QUOTE = `
  mutation($userIds: [String]!, $rootOrganizationId: String!, $useRemoveProration: Boolean) {
    generateQuote(userIds: $userIds, rootOrganizationId: $rootOrganizationId, useRemoveProration: $useRemoveProration)
  }
`;
exports.INVALIDATE_QUOTE = `
  query($rootOrganizationId: String!) {
    invalidateQuote(rootOrganizationId: $rootOrganizationId) }`;
exports.GET_GENERATE_INVOICE_MODAL_INFO = `
query ( $rootOrganizationId: String!) {
  getGenerateInvoiceModalInfo( rootOrganizationId: $rootOrganizationId)  {
      list {
        firstName
        lastName
        userId
        organizationId
        rootOrganizationId
        status
        dateCreated
        expiryDate
        quoteItems {
          productId
          variantSku
          centPrice
          description
          centTaxAmount
          centDiscountedAmount
          amount
          centInvoicePrice
          centDiscountPrice
          isMembership
        }
        aicpaId
      }
      dateCreated
      memberCount
      centCostBefore
      centTotalDiscount
      centTotal
      centTotalTax
      discountDescription
      totalAmount
      totalInvoiceAmount
      centTotalInvoiceDiscount
      centInvoiceCostBefore
   }
  }
`;
exports.APPLY_DISCOUNT_CODE_TO_QUOTE = `
  mutation($rootOrganizationId: String!, $promoCode: String!) {
    applyDiscountCodeToQuote(rootOrganizationId: $rootOrganizationId, promoCode: $promoCode) {
      membersCount
      totalCost
      discountId
      discountCode
      totalDiscountedAmount
      discountDescription
    }
  }
`;
exports.REMOVE_DISCOUNT_CODE_FROM_QUOTE = `
  mutation($rootOrganizationId: String!, $promoId: String!) {
    removeDiscountCodeFromQuote(rootOrganizationId: $rootOrganizationId, promoId: $promoId) {
      membersCount
      totalCost
    }
  }
`;
exports.INIT_QUOTE_GENERATION = `
  mutation($userIds: [String]!, $rootOrganizationId: String!) {
    initQuoteGeneration(userIds: $userIds, rootOrganizationId: $rootOrganizationId) {
      membersCount
      totalCost
      isPendingInvitesActive
    }
  }
`;
exports.GET_FIRM_BILLING_INVOICES = `
    query ($rootOrganizationId: String!, $isPaid: Boolean, $nextPage: String) {
      getFirmBillingInvoices(rootOrganizationId: $rootOrganizationId, isPaid: $isPaid, nextPage: $nextPage) {
        firmBillingInvoices {
          id
          dueDate
          invoiceDate
          amount
          balance
          invoiceNumber
          status
          accountId
          orderNumber
          type
          referenceName
        }
        quotesStatus
        nextPage
      }
    }
`;
exports.GENERATE_INVOICE = `
  mutation($rootOrganizationId: String!, $invoiceReference: String!, $userIds: [String], $isFLP: Boolean) {
    generateInvoice(rootOrganizationId: $rootOrganizationId, invoiceReference: $invoiceReference, userIds: $userIds, isFLP: $isFLP)
  }
`;
exports.GET_ADDONS_BY_CONTENTFUL_SKUS = `
  {
    getAddonsByContentfulSkus
  }
`;
exports.GET_MEMBERSHIP_INVITE_DATA = `
  query getMembershipInviteData($inviteId: String!) {
    getMembershipInviteData(inviteId: $inviteId) {
      email
      firstName
      lastName
      isAlreadyHaveAccount
    }
  }`;
//# sourceMappingURL=firm-admin-queries.js.map